import { getUrl, Request } from "../../request";

export const postTokenLogin = (token) => {
  return Request.post(getUrl("/api/v1/accounts/token-login/"), {
    token,
  });
};

export const getCaptcha = (font_color, color, base_color) => {
  return Request.get(getUrl("/api/v1/accounts/captcha/"), {
    font_color,
    color,
    base_color,
  });
};

export const sendOtp = (phone_number, city_id, captcha_uuid, captcha) => {
  return Request.post(getUrl("/api/v1/accounts/login/"), {
    phone_number,
    city_id,
    captcha_uuid,
    captcha,
  });
};

export const checkOtp = (phone_number, otp_code) => {
  return Request.post(getUrl("/api/v1/accounts/login/"), {
    phone_number,
    otp_code,
  });
};

export const getUserAddresses = (city_id) => {
  return Request.get(getUrl("/api/v1/accounts/user-addresses/"), {
    city_id,
  });
};

export const postUserAddresses = (region_id, address, latitude, longitude, zip_code) => {
  return Request.post(getUrl("/api/v1/accounts/user-addresses/"), {
    region_id,
    address,
    latitude,
    longitude,
    zip_code
  });
};

export const deleteUserAddresses = (id) => {
  return Request.del(getUrl(`/api/v1/accounts/user-addresses/${id}/`));
};

export const putUserAddresses = (
  address_id,
  region_id,
  address,
  latitude,
  longitude,
  zip_code
) => {
  return Request.put(getUrl(`/api/v1/accounts/user-addresses/${address_id}/`), {
    region_id,
    address,
    latitude,
    longitude,
    zip_code
  });
};

export const getUserProfile = () => {
  return Request.get(getUrl("/api/v1/accounts/user/"));
};

export const getUserCredits = (page = null, limit = null) => {
  return Request.get(getUrl("/api/v1/accounts/credit/"), {
    page,
    limit,
  });
};

export const putEditProfile = (
  phone_number,
  first_name,
  last_name,
  nid,
  credit_card
) => {
  return Request.put(getUrl("/api/v1/accounts/user/"), {
    phone_number,
    first_name,
    last_name,
    nid,
    credit_card,
  });
};

// export const getCredits = (
//   type,
//   price_from,
//   price_to,
//   date_from,
//   date_to,
//   sort_value,
//   page
// ) => {
//   const sort_keys = [
//     { id: 1, value: "-created_at" },
//     { id: 2, value: "amount" },
//     { id: 3, value: "-amount" },
//   ];

//   const type_keys = [
//     { id: 1, value: "all" },
//     { id: 2, value: "increase" },
//     { id: 3, value: "decrease" },
//   ];

//   const body = {
//     type:
//       type_keys.find((type_item) => type_item.id === type)?.value ||
//       type_keys[0].value,
//     min_price: price_from ? price_from : null,
//     max_price: price_to ? price_to : null,
//     start_date: date_from ? date_from.format("YYYY/M/D") : null,
//     end_date: date_to ? date_to.format("YYYY/M/D") : null,
//     sort:
//       sort_keys.find((sort_item) => sort_item.id === sort_value)?.value ||
//       sort_keys[0].value,
//     page: page,
//   };
  

//   return new Promise((resolve) => {
//     const data = [{
//       site: 4,
//       date: 'SEP 17/2023',
//       type: "order",
//       orders: [{
//         id: 1156,
//         amount: 50
//       }, {
//         id: 1154,
//         amount: 30
//       }]
//     }, {
//       site: 4,
//       date: 'SEP 15/2023',
//       type: "service",
//       orders: [{
//         id: 123,
//         amount: 50
//       }, {
//         id: 120,
//         amount: 30
//       }]
//     }];
//     setTimeout(() => {
//       resolve({
//         data,
//         // data: new Array(Math.ceil(Math.random() * 15))
//         //   .fill(null)
//         //   .map((_, list_index) => {
//         //     let amount = list_index % 2 === 0 ? 1 : -1;
//         //     if (body.type === "increase") amount = 1;
//         //     else if (body.type === "decrease") amount = -1;
//         //     return {
//         //       id: Math.ceil(Math.random() * 100000),
//         //       site: 4,
//         //       username: "09876543210",
//         //       date: "1399/10/17",
//         //       title: amount === 1 ? "Payment" : "Order",
//         //       amount: amount * Math.ceil(Math.random() * 10000000),
//         //       state: amount === 1 ? "increase" : "decrease",
//         //     };
//         //   }),
//         next: page === 5 ? null : page ? page + 1 : 1,
//         code: 200,
//         pagination: {
//           page: page,
//           next: page === 5 ? null : page + 1,
//         },
//       });
//     }, 50);
//   });
// };